// Catalog attribute values are typed `string | number | boolean`; only numeric power
// ratings are meaningful here, so booleans (and blank strings) are treated as absent.
type RatingValue = string | number | boolean | null | undefined;

const normalize = (v: RatingValue): string => {
  if (typeof v !== 'string' && typeof v !== 'number') return '';
  return `${v}`.trim();
};

/**
 * Formats a generator's LP/gas power ratings as `[LP]/[gas]kW` (e.g. "24/22.5kW").
 * - Both present -> "24/22.5kW"
 * - Only one     -> "24kW" (no slash, no trailing kW)
 * - Neither      -> "" (caller omits the rating entirely)
 *
 * Non-numeric/string values (e.g. booleans) and blank/whitespace strings are treated as absent.
 */
export const formatGeneratorPowerRating = (lp: RatingValue, gas: RatingValue): string => {
  const lpValue = normalize(lp);
  const gasValue = normalize(gas);
  if (lpValue && gasValue) return `${lpValue}/${gasValue}kW`;
  if (lpValue) return `${lpValue}kW`;
  if (gasValue) return `${gasValue}kW`;
  return '';
};
